import axios from "axios";
import { makeUrl } from "../utils";
import { env } from "../../env";

const { facadeBaseUrl, getAllQuotes } = env;

export const fetchAllQuotes = async (
  headers: any,
  sort: { field: string; order: string },
  filter: any
) => {
  let allData: any[] = [];
  let cursor: string | null = null;

  do {
    const url = makeUrl(facadeBaseUrl, getAllQuotes, {
      limit: 1000,
      cursor,
      sort: JSON.stringify([sort.field, sort.order]),
      filter: JSON.stringify(filter),
    });

    const resp = await axios.get(url, { headers });
    const payload = resp.data.data;

    allData = allData.concat(payload.data);
    cursor = payload.pagination?.next_cursor ?? null;
  } while (cursor);

  return allData;
};
